import React, { useEffect, useState } from "react";
import AdminPageLayout from "../components/AdminPageLayout";
import "../components/AdminPageLayout.css";
import { fetchAllSocialMedia, createSocialMedia, updateSocialMedia, deleteSocialMedia } from "./adminSocialMediaService";
import "./socialMedia.css";

const SOCIAL_MEDIA_TYPES = [
  "WHATSAPP_MOBILE", "WHATSAPP_CHANNEL", "WHATSAPP_GROUP",
  "FACEBOOK", "INSTAGRAM", "LINKEDIN", "YOUTUBE", "MOBILE_APP", "WEBSITE",
];

const PLATFORM_ICONS = {
  WHATSAPP_MOBILE: "📱", WHATSAPP_CHANNEL: "📢", WHATSAPP_GROUP: "👥",
  FACEBOOK: "📘", INSTAGRAM: "📸", LINKEDIN: "💼",
  YOUTUBE: "▶️", MOBILE_APP: "📲", WEBSITE: "🌐",
};

const emptyForm = { type: "WHATSAPP_MOBILE", name: "", link: "" };

const AdminSocialMediaPage = () => {
  const [entries, setEntries] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => { loadEntries(); }, []);

  const loadEntries = async () => {
    setLoading(true);
    const res = await fetchAllSocialMedia();
    if (res.status === 200) setEntries(res.data);
    else alert(res.message || "Failed to load");
    setLoading(false);
  };

  const handleSave = async () => {
    if (!form.name.trim() || !form.link.trim()) { alert("Name and Link are required"); return; }
    setLoading(true);
    const res = editing ? await updateSocialMedia(editing.id, form) : await createSocialMedia(form);
    if (res.status === 200 || res.status === 201) {
      setShowForm(false); setEditing(null); setForm(emptyForm); loadEntries();
    } else {
      alert(res.message || "Save failed");
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this entry?")) return;
    const res = await deleteSocialMedia(id);
    if (res.status === 200 || res.status === 204) loadEntries();
    else alert(res.message || "Delete failed");
  };

  const handleCancel = () => { setShowForm(false); setEditing(null); setForm(emptyForm); };

  return (
    <AdminPageLayout
      title="Social Media Links"
      subtitle="Manage all social media and contact links shown in the app."
      instruction="These links appear on the app's Connect / Follow Us screen. Each entry needs a Type (platform), a Display Name, and the URL or phone number. For WhatsApp, enter the full number with country code (e.g. +91XXXXXXXXXX)."
      actions={
        <button className="adm-btn adm-btn-primary" onClick={() => { setEditing(null); setForm(emptyForm); setShowForm(true); }}>
          + Add Entry
        </button>
      }
    >
      {showForm && (
        <div className="adm-form-card">
          <h3>{editing ? "Edit Entry" : "Add New Entry"}</h3>
          <div className="sm-form-grid">
            <div className="form-group">
              <label>Platform Type</label>
              <select name="type" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
                {SOCIAL_MEDIA_TYPES.map((t) => (
                  <option key={t} value={t}>{PLATFORM_ICONS[t]} {t.replace(/_/g, " ")}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Display Name</label>
              <input name="name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="e.g. SpeakBold WhatsApp" />
            </div>
            <div className="form-group">
              <label>URL / Phone Number</label>
              <input name="link" value={form.link} onChange={(e) => setForm({ ...form, link: e.target.value })} placeholder="https://... or +91XXXXXXXXXX" />
            </div>
          </div>
          <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
            <button className="adm-btn adm-btn-primary" onClick={handleSave} disabled={loading}>
              {loading ? "Saving…" : "Save"}
            </button>
            <button className="adm-btn adm-btn-ghost" onClick={handleCancel}>Cancel</button>
          </div>
        </div>
      )}

      {loading && !showForm ? (
        <p className="adm-loading">Loading…</p>
      ) : (
        <div className="adm-table-wrap">
          <table className="adm-table">
            <thead>
              <tr>
                <th>Platform</th>
                <th>Display Name</th>
                <th>Link / Number</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {entries.length === 0 ? (
                <tr><td colSpan="4" className="adm-empty">No entries found</td></tr>
              ) : (
                entries.map((e) => (
                  <tr key={e.id}>
                    <td>
                      <span style={{ marginRight: 6 }}>{PLATFORM_ICONS[e.type]}</span>
                      <span className="adm-badge adm-badge-blue">{e.type.replace(/_/g, " ")}</span>
                    </td>
                    <td style={{ fontWeight: 500 }}>{e.name}</td>
                    <td style={{ maxWidth: 260, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: "#2563eb" }}>
                      <a href={e.link} target="_blank" rel="noreferrer" style={{ color: "inherit" }}>{e.link}</a>
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: 6 }}>
                        <button className="adm-btn adm-btn-ghost adm-btn-sm" onClick={() => { setEditing(e); setForm({ type: e.type, name: e.name, link: e.link }); setShowForm(true); }}>Edit</button>
                        <button className="adm-btn adm-btn-danger adm-btn-sm" onClick={() => handleDelete(e.id)}>Delete</button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </AdminPageLayout>
  );
};

export default AdminSocialMediaPage;
